import { PrimaryFullScreenSpinner, TabLink, TabLinkContainer } from "@repo/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { AdminPageContainer } from "~/components/layout/AdminPageContainer";
import { AdminPageHeader } from "~/components/layout/AdminPageHeader";
import { opsHead } from "~/head";

export const Route = createFileRoute("/__auth/ebury")({
  head: () => opsHead("Ebury"),
  component: () => (
    <Suspense fallback={<PrimaryFullScreenSpinner />}>
      <View />
    </Suspense>
  ),
});

function View() {
  return (
    <AdminPageContainer testId="admin-ebury">
      <AdminPageHeader title="Ebury" />
      <TabLinkContainer className="mb-6" size="sm">
        <TabLink to="/ebury" title="Clients" end />
        <TabLink to="/ebury/trades" title="Trades" />
        <TabLink to="/ebury/beneficiaries" title="Beneficiaries" />
      </TabLinkContainer>
      <Outlet />
    </AdminPageContainer>
  );
}
